import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Save } from "lucide-react";
import { handleSend } from "../../../controllers/controller.all";
import SubmitButton from "../../../components/ui/SubmitButton";


export default function SalleCreate() {
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";
    const ecoleId = user?.ecole?._id || user?.ecole;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        libelle: "",
        capacite: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        const payload = {
            ...formData,
            ecole: ecoleId
        };
        const res = await handleSend(e, "/salle", payload, setLoading, token);
        if (res) {
            navigate("/salles");
        }
    };

    return (
        <div className="flex flex-col gap-6 max-w-2xl mx-auto">
            <div className="flex items-center gap-4">
                <Link to="/salles" className="p-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition text-gray-500">
                    <ArrowLeft className="h-5 w-5" />
                </Link>
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Nouvelle Salle</h1>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden">
                <div className="p-6 space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Nom de la salle *</label>
                        <input 
                            required 
                            type="text" 
                            name="libelle"
                            value={formData.libelle} 
                            onChange={handleChange} 
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                            placeholder="Ex: Salle A1" 
                        />
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Capacité (personnes)</label>
                        <input 
                            type="number" 
                            name="capacite"
                            value={formData.capacite} 
                            onChange={handleChange} 
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                            placeholder="Ex: 30" 
                        />
                    </div>
                </div>
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                    <Link to="/salles" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                        Annuler
                    </Link>
                    <SubmitButton type="submit" isSubmitting={loading} disabled={loading} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition disabled:opacity-50">
                        <Save className="h-4 w-4" />
                        Enregistrer
                    </SubmitButton>
                </div>
            </form>
        </div>
    );
}
